import React from "react";
import Sidebar from "../../components/admin/sidebar/Sidebar";
import { ToastContainer } from "react-toastify";
import { useSelector } from "react-redux";
import { Formik, Form } from "formik";
import * as Yup from "yup";

// internal import
import "./profile.css";
import { FtextField } from "../../components/common/FtextField";
import { FontColor, FourGround } from "../../assets/js/theme";
import Footer from "../../components/admin/footer/Footer";
import useDash from "../../assets/css/dash.module.css";
import {
  getAllCustomerCount,
  passwordUpdate,
  profileUpdate,
} from "../../features/apiCalls";
import { useDispatch } from "react-redux";
import Loader from "../../components/common/Loader";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Tab, Tabs } from "react-bootstrap";
import moment from "moment/moment";
import { badge } from "../../components/common/Utils";
import { useEffect } from "react";
import QrCode from "./QrCode";
import { ispOwnerPermission } from "../../admin/Home/ispOwnerPermission/Permission";
import useISPowner from "../../hooks/useISPOwner";

const Profile = () => {
  const { t } = useTranslation();

  //---> Get user & current user data form useISPOwner hooks
  const { role, ispOwnerId, userData } = useISPowner();

  const netFeeId = useSelector(
    (state) => state.persistedReducer.auth.ispOwnerData?.netFeeId
  );

  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingpass, setIsLoadingpass] = useState(false);
  const [startRedirect, setStartRedirect] = useState(false);
  const [redirectTime, setRedirectTime] = useState(10);
  const [customerCount, setCustomerCount] = useState();
  const [hasFixedBillTime, setHasFixedBillTime] = useState(false);

  // permission state
  const [permissions, setPermissions] = useState([]);

  const passwordValidator = Yup.object({
    mobile: Yup.string()
      // .matches(/^(01){1}[3456789]{1}(\d){8}$/, "মোবাইল নম্বর সঠিক নয়")
      .min(11, t("write11DigitMobileNumber"))
      .max(11, t("over11DigitMobileNumber")),
    oldPassword: Yup.string().required(`${t("oldPassword")} ***`),
    newPassword: Yup.string()
      .required(`${t("newPassword")} ***`)
      .matches(
        /^.*(?=.{8,})(?=.*\d)(?=.*[a-zA-Z]).*$/,
        "Must Contain 8 Characters,   One Alphabat, One Number"
      ),
    confrimPassword: Yup.string().oneOf(
      [Yup.ref("newPassword"), null],
      `${t("doNotMatchPassword")}`
    ),
  });

  const profileValidator = Yup.object({
    name: Yup.string().required(t("writeCustomerName")),
    company: Yup.string(),
    email: Yup.string().email(t("incorrectEmail")),
    address: Yup.string(),
    mobile: Yup.string()
      // .matches(/^(01){1}[3456789]{1}(\d){8}$/, "মোবাইল নম্বর সঠিক নয়")
      .min(11, t("write11DigitMobileNumber"))
      .max(11, t("over11DigitMobileNumber")),
    signature: Yup.string(),
    ...(hasFixedBillTime && { fixedBillTime: Yup.date().required() }),
  });

  const dispatch = useDispatch();
  const progileEditHandler = (formValues) => {
    const data = {
      ...formValues,
      settings: {
        ...userData?.settings,
        hasFixedBillTime,
        fixedBillTime: new Date(formValues.fixedBillTime).toISOString(),
      },
    };

    const sendingData = {
      dispatch,
      data,
      role,
      id: ispOwnerId,
      mobile: userData.mobile,
      setIsLoading,
      setRedirectTime,
      setStartRedirect,
    };

    profileUpdate(sendingData);
  };
  //   change password handler
  const changePasswordHandler = (data) => {
    delete data.confrimPassword;
    const sendingData = {
      data,
      role,
      setIsLoadingpass,
      setRedirectTime,
      setStartRedirect,
    };

    passwordUpdate(sendingData);
  };

  const styles = {
    width: "100%",
    height: "100vh",
    overflow: "hidden",
    position: "fixed",
    top: 0,
    bottom: 0,
    zIndex: "5",
  };

  useEffect(() => {
    role === "ispOwner" && getAllCustomerCount(ispOwnerId, setCustomerCount);

    setPermissions(ispOwnerPermission(userData?.bpSettings));
    setHasFixedBillTime(userData?.settings?.hasFixedBillTime);
  }, []);

  // const handleFileUpload = async (e) => {
  //   const formData = new FormData();
  //   Array.from(e.target.files).forEach((file) => {
  //     formData.append("uploadFile", file);
  //   });

  //   const res = await apiLink.post("/users/file/upload", formData, {
  //     headers: { "Content-Type": "multipart/form-data" },
  //   });

  //   console.log(res.data);
  // };

  return (
    <>
      {startRedirect && (
        <div style={styles}>
          <h3
            className="text-secondary text-center"
            style={{ marginTop: "10rem" }}
          >
            you are being logging out in {redirectTime} seconds...
          </h3>
        </div>
      )}

      {!startRedirect && <Sidebar />}
      <ToastContainer
        className="bg-green"
        toastStyle={{
          backgroundColor: "#677078",
          color: "white",
          fontWeight: "500",
        }}
      />
      <div className={useDash.dashboardWrapper}>
        <div className="container-fluied collector">
          <div className="container">
            {!startRedirect && (
              <FontColor>
                <FourGround>
                  <h2 className="collectorTitle"> {t("profile")} </h2>
                </FourGround>

                <FourGround>
                  <div className="collectorWrapper mt-2 p-3">
                    <Tabs
                      defaultActiveKey={"settings"}
                      id="uncontrolled-tab-example"
                    >
                      <Tab eventKey="settings" title={t("settings")}>
                        <div className="profileWrapper">
                          <div className="profileUpdate">
                            <h5 className="mb-4"> {t("updateProfile")} </h5>
                            <Formik
                              initialValues={{
                                name: userData?.name || "",
                                company: userData?.company || "",
                                email: userData?.email || "",
                                address: userData?.address || "",
                                signature: userData?.signature || "",
                                mobile: userData?.mobile || "",
                                fixedBillTime: userData?.settings?.fixedBillTime
                                  ? new Date(userData.settings.fixedBillTime)
                                  : null,
                              }}
                              validationSchema={profileValidator}
                              onSubmit={(values) => {
                                progileEditHandler(values);
                              }}
                              enableReinitialize
                            >
                              {() => (
                                <Form>
                                  <div className="displayGrid">
                                    <FtextField
                                      type="text"
                                      label={t("name")}
                                      name="name"
                                      validation={true}
                                    />

                                    {role === "ispOwner" && (
                                      <FtextField
                                        type="text"
                                        label={t("company")}
                                        name="company"
                                        validation={true}
                                      />
                                    )}

                                    <FtextField
                                      type="email"
                                      label={t("email")}
                                      name="email"
                                    />

                                    <FtextField
                                      type="text"
                                      label={t("mobile")}
                                      name="mobile"
                                      validation={true}
                                    />

                                    <FtextField
                                      type="text"
                                      label={t("address")}
                                      name="address"
                                    />

                                    {role === "ispOwner" && (
                                      <FtextField
                                        type="text"
                                        label={t("signature")}
                                        name="signature"
                                      />
                                    )}

                                    {role === "ispOwner" && (
                                      <div>
                                        <div className="d-flex align-self-end">
                                          <input
                                            type="checkbox"
                                            className="form-check-input me-1"
                                            id="hasFixedBillTime"
                                            name="hasFixedBillTime"
                                            checked={hasFixedBillTime}
                                            onChange={(e) =>
                                              setHasFixedBillTime(
                                                e.target.checked
                                              )
                                            }
                                          />

                                          <label
                                            className="form-check-label changeLabelFontColor"
                                            htmlFor="hasFixedBillTime"
                                          >
                                            {t("fixedBillTime")}
                                          </label>
                                        </div>

                                        {hasFixedBillTime && (
                                          <FtextField
                                            type="date"
                                            component="DatePicker"
                                            name="fixedBillTime"
                                            showTimeSelect
                                            showTimeSelectOnly
                                            timeIntervals={30}
                                            showTimeCaption={false}
                                            dateFormat="h:mm aa"
                                            placeholderText={t(
                                              "selectDateTime"
                                            )}
                                          />
                                        )}
                                      </div>
                                    )}
                                  </div>

                                  <div className="float-end mt-4">
                                    <button
                                      type="submit"
                                      className="btn btn-success"
                                      disabled={
                                        ispOwnerId ===
                                        "624f41a4291af1f48c7d75c7"
                                      }
                                    >
                                      {isLoading ? <Loader /> : t("update")}
                                    </button>
                                  </div>
                                </Form>
                              )}
                            </Formik>
                          </div>
                          <div className="passwordUpdate">
                            <h5 className="mb-4 marginTop20">
                              {t("changePassword")}
                            </h5>
                            <Formik
                              initialValues={{
                                oldPassword: "",
                                newPassword: "",
                              }}
                              validationSchema={passwordValidator}
                              onSubmit={(values) => {
                                changePasswordHandler(values);
                              }}
                            >
                              {() => (
                                <Form>
                                  <div className="displayGrid">
                                    <FtextField
                                      type="password"
                                      name="oldPassword"
                                      label={t("oldPassword")}
                                      validation={true}
                                    />

                                    <FtextField
                                      type="password"
                                      name="newPassword"
                                      label={t("newPassword")}
                                      validation={true}
                                    />

                                    <FtextField
                                      type="password"
                                      name="confrimPassword"
                                      label={t("againNewPassword")}
                                      validation={true}
                                    />
                                  </div>

                                  <div className="float-end mt-4">
                                    <button
                                      type="submit"
                                      className="btn btn-success"
                                      disabled={
                                        ispOwnerId ===
                                        "624f41a4291af1f48c7d75c7"
                                      }
                                    >
                                      {isLoadingpass ? (
                                        <Loader />
                                      ) : (
                                        t("updatePassword")
                                      )}
                                    </button>
                                  </div>
                                </Form>
                              )}
                            </Formik>
                          </div>
                          {/* <input type="file" onChange={handleFileUpload} /> */}
                        </div>
                      </Tab>
                      <Tab eventKey="profile" title={t("profile")}>
                        <div className="profileWrapper d-flex">
                          <table class="table table-bordered">
                            <tbody>
                              {role === "ispOwner" && (
                                <>
                                  <tr>
                                    <td>{t("netFeeId")}</td>
                                    <td>
                                      <b>{userData?.netFeeId}</b>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>{t("company")}</td>
                                    <td>{userData?.company}</td>
                                  </tr>
                                </>
                              )}
                              <tr>
                                <td>{t("name")}</td>
                                <td>{userData?.name}</td>
                              </tr>
                              <tr>
                                <td>{t("mobile")}</td>
                                <td>{userData?.mobile}</td>
                              </tr>
                              <tr>
                                <td>{t("email")}</td>
                                <td>{userData?.email}</td>
                              </tr>
                              <tr>
                                <td>{t("address")}</td>
                                <td>{userData?.address}</td>
                              </tr>
                              <tr>
                                <td>{t("createdAt")}</td>
                                <td>
                                  {moment(userData?.createdAt).format("lll")}
                                </td>
                              </tr>
                              {role !== "collector" && (
                                <>
                                  <tr>
                                    <td>{t("dueDate")}</td>
                                    <td>
                                      {moment(
                                        userData.bpSettings?.monthlyDueDate
                                      ).format("lll")}
                                    </td>
                                  </tr>
                                </>
                              )}
                            </tbody>
                          </table>
                          {role === "ispOwner" && (
                            <>
                              <table class="table table-bordered">
                                <tbody>
                                  <tr>
                                    <td>{t("package")}</td>
                                    <td>
                                      <b>{userData.bpSettings?.pack}</b>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>{t("packageRate")}</td>
                                    <td>{userData.bpSettings?.packageRate}</td>
                                  </tr>
                                  <tr>
                                    <td>{t("customerLimit")}</td>
                                    <td>
                                      {userData.bpSettings?.customerLimit}
                                    </td>
                                  </tr>
                                  {role === "ispOwner" && (
                                    <tr>
                                      <td>{t("total customer")}</td>
                                      <td>{customerCount?.customersCount}</td>
                                    </tr>
                                  )}
                                  <tr>
                                    <td>{t("customerType")}</td>
                                    <td>
                                      {userData.bpSettings?.customerType.map(
                                        (item) => item + " "
                                      )}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>{t("paymentStatus")}</td>
                                    <td>
                                      {badge(
                                        userData.bpSettings?.paymentStatus
                                      )}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>{t("nonMaskingRate")}</td>
                                    <td>{userData?.smsRate}</td>
                                  </tr>
                                  <tr>
                                    <td>{t("fixedNumberSmsRate")}</td>
                                    <td>{userData?.fixedNumberSmsRate}</td>
                                  </tr>
                                  <tr>
                                    <td>{t("maskingSmsRate")}</td>
                                    <td>{userData?.maskingSmsRate}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </>
                          )}
                        </div>
                      </Tab>

                      {role === "ispOwner" && (
                        <Tab eventKey="controlPanel" title={t("controlPanel")}>
                          <div
                            className="container"
                            style={{ display: "inline-block" }}
                          >
                            <div className="displayGrid3">
                              {permissions?.map((val, key) => (
                                <div className="CheckboxContainer" key={key}>
                                  <input
                                    type="checkbox"
                                    className="CheckBox"
                                    name={val.value}
                                    checked={val.isChecked}
                                    id={val.value + key}
                                    disabled={true}
                                  />
                                  <label className="checkboxLabel">
                                    {val.label}
                                  </label>
                                </div>
                              ))}
                            </div>
                          </div>
                        </Tab>
                      )}

                      {userData.bpSettings?.hasPG && (
                        <Tab eventKey="qrCode" title={t("qrCode")}>
                          <div className="collectorWrapper overflow-hidden">
                            <div className="profileWrapper">
                              <QrCode
                                size={290}
                                ispInfo={{
                                  company: userData?.company,
                                  mobile: userData?.mobile,
                                  netFeeId: netFeeId,
                                  address: userData?.address,
                                }}
                              />
                            </div>
                          </div>
                        </Tab>
                      )}
                    </Tabs>
                  </div>
                </FourGround>
                <Footer />
              </FontColor>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Profile;
